import { z } from 'zod/v3';

export const CoordinatesSchema = z.object({
  x: z.number(),
  y: z.number(),
});
export type Coordinates = z.infer<typeof CoordinatesSchema>;

export const CoordinateSetSchema = z.object({
  topLeft: CoordinatesSchema,
  topRight: CoordinatesSchema,
  bottomLeft: CoordinatesSchema,
  bottomRight: CoordinatesSchema,
  center: CoordinatesSchema,
  width: z.number(),
  height: z.number(),
});
export type CoordinateSet = z.infer<typeof CoordinateSetSchema>;

export const ViewportInfoSchema = z.object({
  scrollX: z.number(),
  scrollY: z.number(),
  width: z.number(),
  height: z.number(),
});
export type ViewportInfo = z.infer<typeof ViewportInfoSchema>;

export const ElementRectSchema = z.object({
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
});
export type ElementRect = z.infer<typeof ElementRectSchema>;
